import { chain, thirdWebClient } from "@/app/libs/thirdweb";
import { escrow, uSPON } from "@/contracts/addresses";
import { ethers } from "ethers";
import { prepareContractCall, sendAndConfirmTransaction } from "thirdweb";
import { getContract } from "thirdweb/contract";
import { Account } from "thirdweb/wallets";

export const withdrawFromEscrow = async (account: Account, amount: bigint, fizzId: bigint) => {
  const contractAddress = escrow;
  const uSponTokenAddress = uSPON;
  try {
    // const uSponTokenContract = getContract({
    //   client: thirdWebClient,
    //   chain,
    //   address: uSponTokenAddress,
    // });

    // const approveRequest = await prepareContractCall({
    //   contract: uSponTokenContract,
    //   method: {
    //     inputs: [
    //       {
    //         internalType: "address",
    //         name: "spender",
    //         type: "address",
    //       },
    //       {
    //         internalType: "uint256",
    //         name: "value",
    //         type: "uint256",
    //       },
    //     ],
    //     name: "approve",
    //     outputs: [
    //       {
    //         internalType: "bool",
    //         name: "",
    //         type: "bool",
    //       },
    //     ],
    //     stateMutability: "nonpayable",
    //     type: "function",
    //   },
    //   params: [contractAddress, amount],
    // });

    // const approveTx = await sendAndConfirmTransaction({
    //   transaction: approveRequest,
    //   account,
    // });
    // console.log(`uSPON token approval successful: ${approveTx.transactionHash}`);

    const escrowContract = getContract({
      client: thirdWebClient,
      chain,
      address: contractAddress,
    });

    const providerAddress = fizzId !== BigInt(0) ? ethers.ZeroAddress : account.address;
    const withdrawRequest = await prepareContractCall({
      contract: escrowContract,
      method: {
        inputs: [
          {
            internalType: "address",
            name: "_provider", // zero address for fizz, provider address for provider
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_fizzId", // 0 for provider & id for fizz
            type: "uint256",
          },
          {
            internalType: "address",
            name: "_token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_amount",
            type: "uint256",
          },
        ],
        name: "withdrawEarnings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
      params: [providerAddress, fizzId, uSponTokenAddress, amount],
    });

    const withdrawRequestTx = await sendAndConfirmTransaction({
      transaction: withdrawRequest,
      account,
    });
    console.log(
      `Withdrawal request successful: ${withdrawRequestTx.transactionHash}`
    );
    return withdrawRequestTx.transactionHash;
  } catch (error) {
    console.error("Error requesting withdrawal:", error);
    throw error;
  }
};
